module.exports = __webpack_public_path__ + "media/images/illustrations/top-uk-schools-009f5413fbba93c36a8c24469b4bd861.svg";